<template>
  <section>
    <div class="container-fluid">
      <div class="container-fluid border-bottom" v-if="isEmpty">
        <div class="row">
          <div class="col-12 text-center">
            <br />
            {{ $t("Menu.list.addons.empty") }}<br />
            <br />
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="addon-list">
          <div
            v-for="(item, index) in possibleItems.addons.outside"
            v-bind:key="'outside-' + index"
            class="col-12"
          >
            <div class="crop-img">
              <img
                :src="imageHost + '/' + item.picture"
                class="thumb"
                :alt="item.text"
              />
            </div>
            <p>
              {{ item.text }}
            </p>
            <a
              type="button"
              class="close"
              aria-label="Close"
              @click="
                changeItemByVarValue(
                  'dropAddon_' + item.id + '_' + item.object + '_1'
                )
              "
            >
              <img
                :src="appUrl + '/img/icons/close.svg'"
                class="icon top"
                alt="close"
              />
            </a>
          </div>
          <div
            v-for="(item, index) in possibleItems.addons.inside"
            v-bind:key="'inside-' + index"
            class="col-6"
          >
            <div class="crop-img">
              <img
                :src="imageHost + '/' + item.picture"
                class="thumb"
                :alt="item.text"
              />
            </div>
            <p>
              {{ item.text }}
            </p>
            <a
              type="button"
              class="close"
              aria-label="Close"
              @click="
                changeItemByVarValue(
                  'dropAddon_' + item.id + '_' + item.object + '_4'
                )
              "
            >
              <img
                :src="appUrl + '/img/icons/close.svg'"
                class="icon top"
                alt="close"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="!addForm">
      <div class="row">
        <div class="col-12 text-center">
          <button @click="addForm = true" class="btn btn-secondary">
            {{ $t("Menu.list.addons.addTitle") }}
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid border-bottom addons" v-else>
      <div class="row">
        <div class="col-10 text-start">
          <h5>{{ $t("Menu.list.addons.addTitle") }}</h5>
          <br />
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="addForm = false"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-4 text-start">
          <label>{{ $t("Menu.list.addons.position.title") }}</label>
        </div>
        <div class="col-8">
          <select v-model="side" class="form-control">
            <option value="1" selected>
              {{ $t("Menu.list.addons.position.outside") }}
            </option>
            <option value="4">
              {{ $t("Menu.list.addons.position.inside") }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-4 text-start">
          <label>{{ $t("Menu.list.addons.object.title") }}</label>
        </div>
        <div class="col-8">
          <select v-model="object" class="form-control">
            <option
              v-for="(object, index) in possibleItems.objectList"
              v-bind:key="index"
              :value="object.id"
            >
              {{ object.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="row addon-list">
        <div
          v-for="(addon, index) in possibleItems.list"
          v-bind:key="index"
          @click="
            changeItemByVarValue(
              'addAddon_' + addon.addon_id + '_' + object + '_' + side
            )
          "
          class="col-12"
        >
          <div class="crop-img">
            <img
              :src="imageHost + '/' + addon.picture"
              class="thumb"
              :alt="addon.text"
            />
          </div>
          <p>
            {{ addon.text }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "VariationsAddons",
  props: ["possibleItems"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      object: "R",
      side: "1",
      addForm: true,
    };
  },
  methods: {
    changeItemByVarValue: function (varValue) {
      this.$parent.$parent.changeItemByVarValue(varValue);
      this.addForm = false;
    },
  },
  computed: {
    isEmpty: function () {
      if (
        typeof this.possibleItems.addons == "undefined" ||
        typeof this.possibleItems.addons.outside == "undefined" ||
        typeof this.possibleItems.addons.inside == "undefined" ||
        (this.possibleItems.addons.outside.length == 0 &&
          this.possibleItems.addons.inside.length == 0)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .addons {
    padding-bottom: 3rem;
  }

  label {
    font-weight: normal;
    line-height: 2.2em;
  }

  div.crop-img {
    width: 7.5rem;
    height: 7.5rem;

    img {
      width: auto;
      height: auto;
    }
  }

  .addon-list {
    margin-top: 3rem;

    p {
      display: inline-flex;
      align-items: center;
      margin: 0;
      padding-left: 1.5rem;
    }
  }

  .addon-list div.col-12 {
    display: flex;
    cursor: pointer;
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 0.1rem solid #ddd;

    &:last-child {
      border-bottom: none;
    }
  }

  a.close {
    margin-left: 1rem;
    display: inline-flex;
    align-items: center;
    font-size: 1.5rem;
  }
}
</style>
